import React from 'react';
import { useLocation } from 'react-router-dom';
import WordDocumentForm from './components/WordDocumentForm';

const Documentation = () => {
  const { state } = useLocation();

  const renderDocumentation = () => {
    switch (state?.params.documentType) {
      case 'new_word':
        return <WordDocumentForm />;

      default:
        return <WordDocumentForm />;
    }
  };

  return renderDocumentation();
};

export default Documentation;
